import { render, staticRenderFns } from "./createNewBtn.vue?vue&type=template&id=674529dd&scoped=true&"
import script from "./createNewBtn.vue?vue&type=script&lang=js&"
export * from "./createNewBtn.vue?vue&type=script&lang=js&"
import style0 from "./createNewBtn.vue?vue&type=style&index=0&id=674529dd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674529dd",
  null
  
)

export default component.exports